// extracted by mini-css-extract-plugin
module.exports = {"root":"m-multiplex_item___KHVS_tK"};